export default function() {
  const route = useRoute()
  let str = ''
  for (let q in route.query) {
    str += q + '-' + route.query[q]
  }
  let query = decodeURI(route.query.search)
  if (query === undefined) query = ''
  let currentPage = route.query.p
  if (currentPage === undefined) currentPage = 1
  let filters = []
  if (route.query.filters !== undefined)
    filters = JSON.parse(decodeURI(route.query.filters))
  return {
    str,
    query,
    currentPage,
    filters,
  }
}
